import createIcon from '../../createIcon';

/**
 * @component @name FontDownloadOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuMjM1MiA5LjA5NDczTDEyLjM2NTIgOC4yMjQ3M0wxMi41OTUyIDcuNTY0NzNIMTIuNjk1MkwxMy4yMzUyIDkuMDk0NzNaTTExLjAwNTIgNi44NjQ3M0wxMS41NzUyIDUuMzQ0NzNIMTMuNzE1MkwxNi4yNjUyIDEyLjEzNDdMMjIuNjU1MiAxOC41MTQ3VjMuMzQ0NzNDMjIuNjU1MiAyLjI0NDczIDIxLjc1NTIgMS4zNDQ3MyAyMC42NTUyIDEuMzQ0NzNINS40ODUyMUwxMS4wMDUyIDYuODY0NzNaTTIxLjE0NTIgMjIuNjU0N0wxOS44MjUyIDIxLjM0NDdINC42NTUyMUMzLjU1NTIxIDIxLjM0NDcgMi42NTUyMSAyMC40NDQ3IDIuNjU1MjEgMTkuMzQ0N1Y0LjE3NDczTDEuMzQ1MjEgMi44NTQ3M0wyLjc1NTIxIDEuNDQ0NzNMMjIuNTU1MiAyMS4yNDQ3TDIxLjE0NTIgMjIuNjU0N1pNMTIuNzU1MiAxNC4yNzQ3TDkuNDU1MjIgMTAuOTc0N0w3LjA2NTIxIDE3LjM0NDdIOS4xNDUyMUwxMC4yMzUyIDE0LjI3NDdIMTIuNzU1MloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FontDownloadOff = createIcon('FontDownloadOff', [
  [
    'path',
    {
      d: 'M13.2352 9.09473L12.3652 8.22473L12.5952 7.56473H12.6952L13.2352 9.09473ZM11.0052 6.86473L11.5752 5.34473H13.7152L16.2652 12.1347L22.6552 18.5147V3.34473C22.6552 2.24473 21.7552 1.34473 20.6552 1.34473H5.48521L11.0052 6.86473ZM21.1452 22.6547L19.8252 21.3447H4.65521C3.55521 21.3447 2.65521 20.4447 2.65521 19.3447V4.17473L1.34521 2.85473L2.75521 1.44473L22.5552 21.2447L21.1452 22.6547ZM12.7552 14.2747L9.45522 10.9747L7.06521 17.3447H9.14521L10.2352 14.2747H12.7552Z',
      key: '196wfu',
    },
  ],
]);

export default FontDownloadOff;
